const topicTitleEnum = {
  "news&social_concern": "News and Social Concern",
  "science&technology": "Science and Technology",
  sports: "Sports",
  "business&entrepreneurs": "Business and Entrepreneurs",
  "diaries&daily_life": "Diaries and Daily Life",
  "celebrity&pop_culture": "Celebrity and Pop Culture",
  gaming: "Gaming",
  "film_tv&video": "Film TV and Video",
  "film_tv&_video": "Film TV and Video",
  music: "Music",
  "fitness&health": "Fitness and health",
  "food&dining": "Food and Dining",
  "learning&educational": "Learning and Educational",
  family: "Family",
  "fashion&style": "Fashion and Style",
};

export { topicTitleEnum };
